import api from './api'

export const usersService = {
  getAll: async (params = {}) => {
    const res = await api.get('/users', { params })
    return res.data
  },

  getById: async (id) => {
    const res = await api.get(`/users/${id}`)
    return res.data.data
  },

  updateStatus: async (id, isActive) => {
    const res = await api.patch(`/users/${id}/status`, { isActive })
    return res.data.data
  },

  // Bulk activate/suspend
  bulkStatus: async (userIds, isActive) => {
    const res = await api.patch('/users/bulk/status', { userIds, isActive })
    return res.data.data
  },

  // Get all orders placed by a specific user (admin route via orders/admin with userId filter)
  getOrders: async (userId, params = {}) => {
    const res = await api.get('/orders/admin', { params: { userId, ...params } })
    return res.data
  },

  // Get current cart for a specific user (admin only)
  getCart: async (userId) => {
    const res = await api.get(`/cart/admin/users/${userId}`)
    return res.data.data
  },
}
